import React from 'react';
import styled from 'styled-components';

type RefundInfoCardProps = {
  nationality?: string;
  passportNumber?: string;
  totalAmount?: number;
  refundAmount?: number;
  qrPaymentAmount?: number;
  paymentAmount?: number;
};

function RefundInfoCard({
  nationality,
  passportNumber,
  totalAmount = 0,
  refundAmount = 0,
  qrPaymentAmount = 0,
  paymentAmount = 0,
}: RefundInfoCardProps) {
  const isCombinedPayment =
    qrPaymentAmount !== 0 &&
    paymentAmount !== 0 &&
    qrPaymentAmount !== paymentAmount;

  return (
    <Container>
      <Header>
        <HeaderTitle>환급 정보</HeaderTitle>
        <HeaderRight>TAX REFUND</HeaderRight>
      </Header>
      <Content>
        <InfoRow>
          <InfoLabel>국적</InfoLabel>
          <InfoValue>{nationality}</InfoValue>
        </InfoRow>
        <InfoRow isHasBottomBorder>
          <InfoLabel>여권번호</InfoLabel>
          <InfoValue>{passportNumber}</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>의료 금액</InfoLabel>
          <InfoValue>{totalAmount.toLocaleString()}원</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>환급액</InfoLabel>
          <InfoValue>{refundAmount.toLocaleString()}원</InfoValue>
        </InfoRow>
        {isCombinedPayment && (
          <InfoRow>
            <InfoLabel>해외 간편 결제 금액</InfoLabel>
            <InfoValue>{qrPaymentAmount.toLocaleString()}원</InfoValue>
          </InfoRow>
        )}
        <InfoRow>
          <InfoLabel>결제 금액</InfoLabel>
          <InfoValue isBold>{paymentAmount.toLocaleString()}원</InfoValue>
        </InfoRow>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  background-color: #f4f8ff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 20px 16px;
  border-bottom: 1px solid #e5e6e8;
`;

const HeaderTitle = styled.h2`
  color: var(--KTP-Mono-100, var(--KTP-Color-Mono-100, #030303));

  /* KTPHead/02_18SB */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
`;

const HeaderRight = styled.div`
  color: var(--KTP-Primary-100, var(--KTP-Color-Primary-100, #246cf6));
  text-align: right;

  /* KTPBody/01_16MD */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
`;

const Content = styled.div`
  padding: 17px 20px 20px;
`;

const InfoRow = styled.div<{ isBold?: boolean; isHasBottomBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  ${({ isHasBottomBorder }) =>
    isHasBottomBorder &&
    `
    border-bottom: 1px solid #E5E6E8;
    padding-bottom: 16px;
    `}

  &:last-child {
    margin-bottom: 0;
  }
`;

const InfoLabel = styled.span`
  color: var(--KTP-Mono-50, var(--KTP-Color-Mono-50, #80848a));

  /* KTPBody/02_14MD */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const InfoValue = styled.span<{
  isBold?: boolean;
}>`
  color: var(--KTP-Mono-100, var(--KTP-Color-Mono-100, #030303));
  text-align: right;

  /* KTPBody/01_16MD */
  font-family: Pretendard;
  line-height: 150%; /* 24px */

  color: #000000;
  text-align: right;
  font-weight: ${({ isBold }) => (isBold ? '700' : '500')};
  font-size: ${({ isBold }) => (isBold ? '18px' : '16px')};
`;

export default RefundInfoCard;
